import { TextInput } from '@cbhq/cds-web/controls';

import { FieldCopy } from './FieldCopy';

interface ProjectNameFieldProps {
  handleOnChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  projectName: string;
  handleOnBlur: () => void;
  projectNameError: string;
}
export function ProjectNameField({
  projectName,
  projectNameError,
  handleOnChangeName,
  handleOnBlur,
}: ProjectNameFieldProps) {
  return (
    <>
      <FieldCopy
        title="Name your project"
        description="Give your project a name. This name is private and can only be viewed by you and your collaborators."
      />
      <TextInput
        placeholder="Project 1"
        value={projectName}
        onChange={handleOnChangeName}
        onBlur={handleOnBlur}
        helperText={projectNameError || ''}
        variant={projectNameError ? 'negative' : undefined}
      />
    </>
  );
}
